import React from 'react';
import {styled} from '@mui/material/styles';

const StatusBadgeBase = styled('span')(()=>({
    'height': '28px',
    'fontSize': '0.8125em',
    'fontWeight': 500,
    'color': '#fff',
    'textAlign': 'center',
    'textTransform': 'uppercase',
    'padding': '3px 7px 3px 7px',
    'borderRadius': '4px',
    'lineHeight': 1.8,
    'letterSpacing': '0.02857em',
    'display': 'inline-block',
}));

function StatusBadgeComponent({status = '', ...props}) {
    return <StatusBadgeBase data-status={status} {...props}>{status}</StatusBadgeBase>;
}
// TODO: split into multiple components - per Publisher/Endpoint/WL/Transaction
export const CommonStatusBadge = styled(StatusBadgeComponent)(({theme}) => ({
    '&[data-status="active" i]': {
        backgroundColor: theme.palette.statusActive.main,
    },
    '&[data-status="new" i]': {
        backgroundColor: theme.palette.statusNew.main,
    },
    '&[data-status="paused" i]': {
        backgroundColor: theme.palette.statusPaused.main,
    },
    '&[data-status="removed" i]': {
        backgroundColor: theme.palette.statusRemoved.main,
    },
    '&[data-status="pending" i]': {
        backgroundColor: theme.palette.statusRemoved.main,
    },

}));

export const GatewayStatusBadge = styled(StatusBadgeComponent)(()=>({
    '&[data-status="manual" i]': {
        backgroundColor: '#1578b6',
    },
    '&[data-status="crypto" i]': {
        backgroundColor: '#3ed436',
    },
    '&[data-status="paypal" i]': {
        backgroundColor: '#f6ab2e',
    },
    '&[data-status="new" i]': {
        backgroundColor: '#1578b6',
    },
    '&[data-status="succeeded" i]': {
        backgroundColor: '#3ed436',
    },
}));
